import { computed, inject, Injectable, NgZone, signal } from '@angular/core';
import { Keyboard } from '@capacitor/keyboard';
import { KeyboardService } from './keyboard.service';

@Injectable()
export class NativeKeyboardService extends KeyboardService {
  private zone = inject(NgZone);
  private height = signal(0);

  readonly keyboardHeight = this.height.asReadonly();
  readonly isKeyboardOpen = computed(() => this.height() > 0);

  init(): void {
    Keyboard.addListener('keyboardWillShow', (info) =>
      this.zone.run(() => this.applyKeyboardHeight(info.keyboardHeight)),
    );
    Keyboard.addListener('keyboardWillHide', () =>
      this.zone.run(() => this.applyKeyboardHeight(0)),
    );
  }

  private applyKeyboardHeight(height: number): void {
    this.height.set(height);
    document.documentElement.style.setProperty(
      '--keyboard-height',
      `${height}px`,
    );
    document.documentElement.classList.toggle('keyboard-open', height > 0);
  }
}
